import React from 'react'
import './about.css'
import {FaGraduationCap} from 'react-icons/fa'
import {GiWorld, GiConversation} from 'react-icons/gi'
import Languages from '../Languages/Languages'

function About() {
  return (
    <section className='about' id='about'>
      <div className='container'>
        <h2 className='about-title'>Sobre mi</h2>
        <h5 className='about-text'>Desarrollador <strong>Front End React</strong> con conocimientos <strong>Full Stack MERN (MongoDB, Express, React y Node.js)</strong> y experiencia en herramientas de diseño como Figma. Apasionado por la creación de sitios web y aplicaciones que combinan funcionalidad, usabilidad y diseño atractivo.</h5>
        <div className='about-container mb-4 mb-lg-0'>
          <div className='about-item flex-column align-items-start'>
            <div className='d-flex justify-content-center align-items-center'>
              <FaGraduationCap className='about-item-logo'/>
              <h5 className='about-item-title'>Formación:</h5>
            </div>
            <ul className='text-start'>
              <li><h5 className='about-item-title'><strong className='about-item-text'> Full Stack Web Developer - Rolling Code</strong></h5></li>
              <li><h5 className='about-item-title'><strong className='about-item-text'> Lic. Admin. de Empresas - Universidad Nacional deTucumán</strong></h5></li>
            </ul>
          </div>
          <div className='about-item'>
            <GiConversation className='about-item-logo'/>
            <h5 className='about-item-title'>Idiomas:<strong className='about-item-text'> Español (nativo) - Ingles (B2)</strong></h5>
          </div>
          <div className='about-item'>
            <GiWorld className='about-item-logo'/>
            <h5 className='about-item-title'>Ubicación:<strong className='about-item-text'> Granada - ESP</strong></h5>
          </div>
        </div>
      </div>
      <div className='stack-container'>
        <div className='stack-box'>
          <h3 className='stack-text'> Lenguajes/Skills </h3>
          <Languages/>
        </div>
      </div>
    </section>
  )
}

export default About